
const tempo =
    {
        key:"2cb99fbf4724431083864ac1de1f9901",
        baseurl:"api.openweathermap.org/data/2.5",
        cityID:"2265552"
    };

export default tempo